<div class="closing-x-wrap">
    <mat-icon (click)="closeModal()" class="close-icon">close</mat-icon>
</div>

<!-- if we are displaying system docs, give them a drop down of the 10 most recent versions -->
<ng-container *ngIf="doc.systemDocumentTypeId === 3">
    <mat-form-field>
        <mat-label>Release Notes</mat-label>
        <mat-select (selectionChange)="displayHtml($event.value)" [(value)]="doc">
            <mat-option *ngFor="let doc of docList" [value]="doc">{{ doc.systemDocumentDescription }} - {{ doc.versionNumber }}</mat-option>
        </mat-select>
    </mat-form-field>
</ng-container>
<div mat-dialog-content class="doc-container">
    <div *ngIf="pdfToRender">
        <a *ngIf="!pdfLoading" href="{{ pdfToRender }}" target="_blank" download> <button mat-raised-button class="button primary-btn">Download</button></a>

        <pdf-viewer
            [src]="pdfToRender"
            [render-text]="false"
            [original-size]="false"
            [autoresize]="true"
            (on-progress)="onProgress($event)"
            style="height: {{ viewerHeight }}px; width: {{ viewerWidth }} px"
        ></pdf-viewer>
    </div>
</div>
